$(document).ready(function () {
    $('.otherchoice').hide();
    getProgramme();
    $('#programme').change(getProgramme);

    function getProgramme() {
        if ($('#programme').val() == 'bscmedsci-medical-sciences' || $('#programme').val() == 'external-intercalating' || $('#programme').val() == 'postgrad') {
            $('.otherchoice').fadeIn();
        } else {
            $('.otherchoice').fadeOut();
        }
        if ($('#programme').val() == 'external-intercalating') {
            $('label[for="other_course_location"], select[name="other_course_location"]').show();
            $('.external-intercalating-information').show();
        } else {
            $('label[for="other_course_location"], select[name="other_course_location"]').hide();
            $('.external-intercalating-information').hide();
        }
    }
});
